import { Emblem } from "./Brand";

// Thin rule interrupted by a small emblem — a quiet brand mark between sections.
// tone="light" for cream sections; tone="dark" wraps the emblem in an ivory coin so it reads on navy.
export const EmblemDivider = ({ tone = "light", className = "" }) => {
  const dark = tone === "dark";
  const rule = dark ? "bg-[#24355A]" : "bg-[#D9CFB8]";
  return (
    <div aria-hidden="true" data-testid={`emblem-divider-${tone}`} className={`max-w-[1300px] mx-auto px-6 lg:px-10 ${className}`}>
      <div className="flex items-center gap-6">
        <span className={`h-px flex-1 ${rule}`} />
        <span className={`inline-flex items-center justify-center shrink-0 rounded-full ${dark ? "w-12 h-12" : "w-11 h-11"}`}
          style={dark ? { background: "#FDFBEE" } : undefined}>
          <Emblem sizes="40px" testId={`emblem-divider-${tone}-img`} className={`${dark ? "w-9 h-9" : "w-11 h-11"} object-contain`} />
        </span>
        <span className={`h-px flex-1 ${rule}`} />
      </div>
    </div>
  );
};
